module.exports = __webpack_public_path__ + "img/soil.48e721f1.png";